var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-sticker-modal-component" }, [
    _c(
      "div",
      { staticClass: "room-sticker-modal" },
      [
        _c("RoomStickerList"),
        _c(
          "button",
          {
            staticClass: "room-sticker-button",
            on: {
              click: function ($event) {
                return _vm.removeSticker()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("sticker.erase")))]
        ),
        _vm.hasEmceeRole()
          ? _c(
              "button",
              {
                staticClass: "room-sticker-button",
                on: {
                  click: function ($event) {
                    return _vm.removeAllSticker()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("sticker.eraseAll")))]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }